var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 7C21.0095 6.93032 21.0095 6.85968 21 6.79C20.9913 6.73129 20.9745 6.67407 20.95 6.62C20.9236 6.57113 20.8935 6.52433 20.86 6.48C20.822 6.41675 20.7748 6.35947 20.72 6.31L20.6 6.24C20.5423 6.19696 20.4782 6.16321 20.41 6.14H20.21C20.1491 6.08099 20.0779 6.03356 20 6H15C14.7348 6 14.4804 6.10536 14.2929 6.29289C14.1054 6.48043 14 6.73478 14 7C14 7.26522 14.1054 7.51957 14.2929 7.70711C14.4804 7.89464 14.7348 8 15 8H17.83L13.83 12.71L9.51 10.14C9.30538 10.0183 9.06406 9.97359 8.82942 10.0139C8.59479 10.0542 8.38224 10.177 8.23 10.36L3.23 16.36C3.06026 16.5642 2.9786 16.8275 3.00298 17.0919C3.02736 17.3564 3.15578 17.6003 3.36 17.77C3.56422 17.9397 3.8275 18.0214 4.09192 17.997C4.35635 17.9726 4.60026 17.8442 4.77 17.64L9.22 12.3L13.49 14.86C13.6925 14.9801 13.931 15.0249 14.1633 14.9865C14.3956 14.9481 14.6069 14.8289 14.76 14.65L19 9.7V12C19 12.2652 19.1054 12.5196 19.2929 12.7071C19.4804 12.8946 19.7348 13 20 13C20.2652 13 20.5196 12.8946 20.7071 12.7071C20.8946 12.5196 21 12.2652 21 12V7Z",
    fill: "#FA6B7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02);
export default __webpack_public_path__ + "static/media/02.0491c7e0f595119e8ccaec5b2179b23e.svg";
export { ForwardRef as ReactComponent };